/**
 * Whether S1 offers "Run test registration": REACT_APP_FEATURE_REGISTER_DRY_RUN=true, or the
 * variable unset in a development build. The backend honours the request only when its own
 * FEATURE_REGISTER_DRY_RUN is on.
 */
export function isRegisterDryRunEnabled(): boolean {
  return (
    process.env.REACT_APP_FEATURE_REGISTER_DRY_RUN === 'true' ||
    (!process.env.REACT_APP_FEATURE_REGISTER_DRY_RUN &&
      process.env.NODE_ENV === 'development')
  );
}
